module.exports = __webpack_public_path__ + "pc/img/二维码.e657ae72.png";